var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canAddProduct
    ? _c(
        "div",
        { staticClass: "pdp-variant-selector" },
        [
          _c("h3", { staticClass: "pdp-variant-selector-heading" }, [
            _vm._v("\n    " + _vm._s(_vm.product.type) + "\n  ")
          ]),
          _vm._v(" "),
          _vm.hasInventory
            ? _c("div", { staticClass: "pdp-variant-selector-price-area" }, [
                _vm.selectedVariant
                  ? _c("div", { staticClass: "pdp-variant-selector-price" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.formattedPrice(_vm.variantPrice())) +
                          "\n    "
                      )
                    ])
                  : _c("div", { staticClass: "pdp-variant-selector-price" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.formattedPrice(_vm.product.price)) +
                          "\n    "
                      )
                    ]),
                _vm._v(" "),
                _c("div", { staticClass: "pdp-variant-selector-unit-price" }, [
                  _vm.packOptions.length >= 1 && _vm.hasUnitDivisor
                    ? _c("span", [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.formattedUnitPrice(_vm.unitDivisor)) +
                            "\n        " +
                            _vm._s(_vm.product.unitPriceText) +
                            "\n      "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pdp-variant-selector-compare" }, [
                  _vm.selectedVariant && _vm.selectedVariant.compareAtPrice
                    ? _c(
                        "span",
                        {
                          staticClass: "pdp-variant-selector-compare-text-price"
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.translations.previousPriceText) +
                              "\n        "
                          ),
                          _c("strike", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.formattedPrice(
                                    _vm.selectedVariant.compareAtPrice
                                  )
                                ) +
                                "\n        "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedVariant && _vm.selectedVariant.compareAtPrice
                    ? _c(
                        "span",
                        { staticClass: "pdp-variant-selector-compare-saving" },
                        [
                          _vm._v(
                            "\n        -" +
                              _vm._s(
                                _vm.formattedPrice(
                                  _vm.selectedVariant.compareAtPrice -
                                    _vm.variantPrice()
                                )
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            : _c("div", { staticClass: "pdp-variant-selector-sold-out" }, [
                _vm._v("\n    " + _vm._s(_vm.translations.soldOut) + "\n  ")
              ]),
          _vm._v(" "),
          _vm.hasVariants
            ? [
                _c("div", { staticClass: "pdp-variant-selector-description" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.sectionSettings.headerText) +
                      "\n    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pdp-variant-selector-field" },
                  [
                    _c("RadioButtonGroup", {
                      attrs: {
                        options: _vm.packOptions,
                        selected: _vm.selected
                      },
                      on: { change: _vm.updateSelectedOption }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "pdp-variant-selector-description" }, [
                  _c("em", [_vm._v(_vm._s(_vm.retrieveCustomDescription))])
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.hasInventory
            ? _c("div", { staticClass: "pdp-variant-selector-description" }, [
                _vm._v(
                  "\n    " + _vm._s(_vm.translations.quantityText) + "\n  "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasInventory
            ? _c(
                "div",
                { staticClass: "pdp-variant-selector-field" },
                [
                  _c("QuantitySelector", {
                    attrs: {
                      minimum: _vm.minimumQuantity,
                      "inventory-quantity": _vm.inventoryQuantity,
                      "inventory-policy-is-continue":
                        _vm.selectedVariant.inventoryPolicyIsContinue,
                      selected: _vm.selected
                    },
                    on: { quantityUpdateEmit: _vm.updateQuantity },
                    model: {
                      value: _vm.quantity,
                      callback: function($$v) {
                        _vm.quantity = $$v
                      },
                      expression: "quantity"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isSubscriptionProduct && _vm.hasInventory
            ? _c("div", { staticClass: "purchase-type-selector-description" }, [
                _vm._v(
                  "\n    " + _vm._s(_vm.translations.frequencyText) + "\n  "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isSubscriptionProduct && _vm.hasInventory
            ? _c(
                "div",
                { staticClass: "purchase-type-selector-field" },
                [
                  _c("PurchaseTypeSelector", {
                    attrs: {
                      "discount-percentage": _vm.product.discountPercentage,
                      translations: _vm.translations,
                      "selected-variant": _vm.selectedVariant
                    },
                    on: { purchaseTypeUpdateEmit: _vm.updatePurchaseType },
                    model: {
                      value: _vm.purchaseType,
                      callback: function($$v) {
                        _vm.purchaseType = $$v
                      },
                      expression: "purchaseType"
                    }
                  }),
                  _vm._v(" "),
                  _vm.purchaseType === _vm.RECHARGE_PURCHASE_TYPES.SUBSCRIPTION
                    ? _c("SubscriptionIntervalSelector", {
                        attrs: {
                          "delivery-interval": _vm.deliveryInterval,
                          "shipping-interval-frequency":
                            _vm.product.shippingIntervalFrequency,
                          "shipping-interval-unit-type":
                            _vm.product.shippingIntervalUnitType,
                          translations: _vm.translations
                        },
                        on: {
                          deliveryIntervalUpdateEmit: _vm.updateDeliveryInterval
                        },
                        model: {
                          value: _vm.deliveryInterval,
                          callback: function($$v) {
                            _vm.deliveryInterval = $$v
                          },
                          expression: "deliveryInterval"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canAddProduct
            ? [
                _c("ButtonCTA", {
                  attrs: {
                    product: _vm.product,
                    "selected-variant": _vm.selectedVariant,
                    quantity: _vm.quantity,
                    translations: _vm.translations,
                    "variant-price": _vm.variantPrice(),
                    "purchase-type": _vm.purchaseType,
                    "delivery-interval": _vm.deliveryInterval,
                    "shipping-interval-unit-type":
                      _vm.product.shippingIntervalUnitType
                  }
                })
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.canFindInStore
            ? _c("a", {
                staticClass: "pdp-variant-selector-store-finder",
                attrs: { href: _vm.developerSettings.storeLink },
                domProps: { innerHTML: _vm._s(_vm.storeFindButtonText) }
              })
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }